import verifyEmailRoutes from "../../modules/verifyEmail/router/index";
import findEmailRoutes from "../../modules/findEmail/router/index";
import gmailExtensionRoutes from "../../modules/gmailExtension/router/index";
import searchPeopleRoutes from "../../modules/searchPeople/router/index";
import creditHistoryRoutes from '../../modules/creditHistory/router/index'

export default [
  ...findEmailRoutes,
  ...verifyEmailRoutes,
  ...gmailExtensionRoutes,
  ...searchPeopleRoutes,
  ...creditHistoryRoutes
];
